/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Latest_VersionInputs */

const en_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Latest version: ${i?.version}`)
};

const fr_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière version : ${i?.version}`)
};

const de_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neueste Version: ${i?.version}`)
};

const it_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima versione: ${i?.version}`)
};

const ru_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Последняя версия: ${i?.version}`)
};

const es_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última versión: ${i?.version}`)
};

const zh_cn2_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最新版本：${i?.version}`)
};

const ja_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最新バージョン: ${i?.version}`)
};

const hi_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`नवीनतम संस्करण: ${i?.version}`)
};

const pt_pt2_latest_version = /** @type {(inputs: Latest_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última versão: ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Latest version: {version}" |
*
* @param {Latest_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const latest_version = /** @type {((inputs: Latest_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Latest_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_latest_version(inputs)
	if (locale === "de") return de_latest_version(inputs)
	if (locale === "it") return it_latest_version(inputs)
	if (locale === "ru") return ru_latest_version(inputs)
	if (locale === "es") return es_latest_version(inputs)
	if (locale === "zh-CN") return zh_cn2_latest_version(inputs)
	if (locale === "ja") return ja_latest_version(inputs)
	if (locale === "hi") return hi_latest_version(inputs)
	if (locale === "pt-PT") return pt_pt2_latest_version(inputs)
	return en_latest_version(inputs)
});